export const ASSET_IMAGES = "/images";
export const ASSET_AVATARS = ASSET_IMAGES + "/avatar";
export const ASSET_LOGOS = ASSET_IMAGES + "/logos";
